import React, { useEffect, useRef } from 'react';
import { message } from 'antd';

export const SaveIcon = ({ saveIcon }) => {
  const key = 'updatable';
  const prevSaveIconRef = useRef(saveIcon);

  useEffect(() => {
    const prev = prevSaveIconRef.current;
    if (saveIcon) {
      message.loading({ content: 'Daten werden gespeichert...', key });
    } else if (prev) {
      // Nur nach echtem Speichervorgang (war kurz auf true), nicht beim ersten Mount mit false
      message.success({ content: 'Erfolgreich gespeichert', duration: 2, key });
    }
    prevSaveIconRef.current = saveIcon;
  }, [saveIcon]);

  return <div />;
};
